import { Injectable } from '@angular/core';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {ReportView} from '../interfaces/ReportView';
import {ReportService} from '../services/report/report.service';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class ReportViewResolverService extends BreadCrumbAndDataResolverService<ReportView> {
    constructor(private reportService: ReportService, helper: BreadCrumbAndDataHelperService) {
        super(helper);
    }

    public async getData(route: ActivatedRouteSnapshot): Promise<ReportView> {
        return await this.reportService.getReportView(Number(route.params.reportViewId));
    }

    public getName(data: ReportView): string {
        return `${data.name}`;
    }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/resolvers/report-view-resolver.service.ts